import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import { useBusiness } from '../contexts/BusinessContext';

const BusinessSwitcher: React.FC = () => {
  const { businesses, selectedBusinessId, setSelectedBusinessId, isLoading } = useBusiness();

  if (isLoading || businesses.length === 0) {
    return null;
  }

  const handleChange = (event: SelectChangeEvent) => {
    setSelectedBusinessId(event.target.value);
  };

  // Sorted here rather than in BusinessContext, whose first-business
  // fallback default depends on the API's original order.
  const sortedBusinesses = [...businesses].sort((a, b) =>
    a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' })
  );

  return (
    <FormControl sx={{ minWidth: { xs: '100%', sm: 260 }, flexGrow: { xs: 1, sm: 0 } }} size="small">
      <InputLabel id="business-switcher-label">Business</InputLabel>
      <Select
        labelId="business-switcher-label"
        id="business-switcher"
        value={selectedBusinessId ?? ''}
        label="Business"
        onChange={handleChange}
        startAdornment={<BusinessIcon sx={{ ml: 1, mr: 0.5, color: 'action.active' }} />}
      >
        {sortedBusinesses.map((business) => (
          <MenuItem key={business.id} value={business.id}>
            {business.name} ({business.deviceCount} devices)
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default BusinessSwitcher;
